import { makeStyles } from "@material-ui/core";
import { getContrastText } from "util/contrastColor";
/* -------------------------------------------------------------------------- */
const TOOLTIP_COLOR = "#FFEFD9";
/* -------------------------------------------------------------------------- */
export const useStyles = makeStyles((theme) => ({
  tooltip: {
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 200,
  },
  poper: {
    "& .MuiTooltip-arrow": {
      color: TOOLTIP_COLOR,
    },
    "& .MuiTooltip-tooltip": {
      backgroundColor: TOOLTIP_COLOR,
      color: getContrastText(TOOLTIP_COLOR),
      padding: theme.spacing(1.5),
      // Popper centers this bubble vertically on its anchor ("right"
      // placement) and, confirmed live, doesn't reliably reposition a tall
      // bubble to avoid the viewport edge — so the taller the cap, the
      // further a bubble anchored anywhere but dead-center can overflow
      // (half its height extends each way from the anchor). 50vh is a
      // compromise: generous enough for most content, small enough to
      // keep that overflow modest for a typical anchor position. Either
      // way, overflow-y: auto is the actual safety net — it guarantees
      // every line stays reachable by scrolling inside the bubble even
      // when its own edge still pokes past the viewport a little.
      maxHeight: "50vh",
      overflowY: "auto",
    },
  },
}));
